import React, { LegacyRef, forwardRef } from 'react';

import { RoundButton } from '../RoundButton';
import { View } from 'react-native';

const helpImage = require('assets/help.svg');

export const SOSButton = forwardRef(
  (props: { onPress: () => void }, ref: LegacyRef<View>) => (
    <View ref={ref}>
      <RoundButton onPress={props.onPress} image={helpImage} color={'#000'} />
    </View>
  ),
);
